import ConnectionsSettings from "../components/settings/ConnectionsSettings";

export default function MobileIntegracionesSettings() {
  return <ConnectionsSettings />;
}
